<template>
    <div class="property-request-confirm">
        <!-- Dialog tạo / chỉnh sửa / tiếp nhận chi tiết phiếu -->
        <create-dialog v-model="dialog" :item="item" @fetchData="fetchData" @setSelect="setSelect"></create-dialog>

        <!-- Card danh sách chính -->
        <v-card class="rounded-xl elevation-3 overflow-hidden">
            <!-- Tiêu đề và nhóm nút chức năng chính -->
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Tiếp nhận phiếu công cụ dụng cụ
                <v-spacer></v-spacer>

                <!-- Nút Tải lại dữ liệu -->
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="fetchData()" outlined color="green lighten-3" class="rounded-lg" block
                        style="width: 40px !important; height: 40px; padding: 0px;" title="Tải lại dữ liệu">
                        <v-icon color="green darken-4">mdi-refresh</v-icon>
                    </v-btn>
                </div>

                <v-divider vertical class="mx-3"></v-divider>

                <!-- Nút Mở dialog xuất Excel -->
                <v-btn outlined @click="dialogExcel = true" color="teal darken-4"
                    class="rounded-pill elevation-1 ml-2 font-weight-bold" style="text-transform: none;">
                    <v-icon left small>mdi-file-excel</v-icon> Xuất excel
                </v-btn>

                <!-- Nút Mở dialog tiếp nhận hàng loạt -->
                <v-btn @click="receiveDialog = true" dark color="orange darken-4"
                    class="rounded-pill elevation-2 ml-3 font-weight-bold px-5">
                    <v-icon left>mdi-check-all</v-icon> TIẾP NHẬN
                </v-btn>

                <!-- Nút Thêm / Tạo phiếu mới -->
                <v-btn @click="createItem" dark color="teal darken-4"
                    class="rounded-pill elevation-3 ml-3 font-weight-bold px-6">
                    <v-icon left>mdi-plus</v-icon> TẠO PHIẾU
                </v-btn>
            </v-card-title>

            <!-- Thanh bộ lọc tìm kiếm -->
            <v-sheet class="grey lighten-4 py-4 px-6">
                <v-row class="mx-n2" align="center">
                    <!-- Từ ngày -->
                    <v-col cols="12" sm="6" md="2" class="py-1">
                        <v-text-field v-model="from" label="Từ ngày" type="date" hide-details outlined dense
                            prepend-inner-icon="mdi-calendar-start" background-color="white" class="rounded-lg"></v-text-field>
                    </v-col>

                    <!-- Đến ngày -->
                    <v-col cols="12" sm="6" md="2" class="py-1">
                        <v-text-field v-model="to" label="Đến ngày" type="date" hide-details outlined dense
                            prepend-inner-icon="mdi-calendar-end" background-color="white" class="rounded-lg"></v-text-field>
                    </v-col>

                    <!-- Lọc theo mã phiếu -->
                    <v-col cols="12" sm="6" md="2" class="py-1">
                        <v-text-field v-model="filterCode" hide-details outlined dense placeholder="Nhập mã phiếu..." label="Mã phiếu"
                            prepend-inner-icon="mdi-identifier" background-color="white" class="rounded-lg" clearable></v-text-field>
                    </v-col>

                    <!-- Lọc theo trạng thái -->
                    <v-col cols="12" sm="6" md="2" class="py-1">
                        <v-select v-model="filterStatus" hide-details outlined dense :items="statusFilterOptions" clearable
                            label="Trạng thái" prepend-inner-icon="mdi-filter-variant" background-color="white" class="rounded-lg"></v-select>
                    </v-col>

                    <!-- Lọc theo phòng ban -->
                    <v-col cols="12" sm="6" md="2" class="py-1">
                        <v-text-field v-model="filterDepartment" hide-details outlined dense placeholder="Nhập phòng ban..." label="Phòng ban"
                            prepend-inner-icon="mdi-office-building" background-color="white" class="rounded-lg" clearable></v-text-field>
                    </v-col>

                    <!-- Tìm kiếm từ khóa chung -->
                    <v-col cols="12" sm="6" md="2" class="py-1">
                        <v-text-field v-model="search" hide-details outlined dense placeholder="Tìm kiếm nhanh..." label="Tìm kiếm"
                            prepend-inner-icon="mdi-magnify" background-color="white" class="rounded-lg" clearable></v-text-field>
                    </v-col>
                </v-row>
            </v-sheet>

            <!-- Bảng dữ liệu phiếu -->
            <v-data-table :items="filteredItems" :headers="headers" height="calc(100vh - 320px)" :search="search"
                :loading="isLoading" loading-text="Đang tải dữ liệu..." fixed-header class="elevation-0"
                :footer-props="{'items-per-page-options': [15, 30, 50, -1]}">

                <!-- Thao tác chi tiết và xóa -->
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex align-center justify-center">
                        <v-btn x-small depressed rounded color="teal lighten-5" class="mx-1 teal--text text--darken-3 font-weight-bold"
                            @click="edit(item)" title="Xem chi tiết / Tiếp nhận">
                            <v-icon left small>mdi-eye</v-icon> Chi tiết
                        </v-btn>
                        <v-btn x-small depressed rounded color="red lighten-5" class="mx-1 red--text text--darken-3 font-weight-bold"
                            @click="deleteItem(item)" title="Xóa phiếu">
                            <v-icon left small>mdi-delete</v-icon> Xóa
                        </v-btn>
                    </div>
                </template>

                <!-- Hiển thị mã phiếu -->
                <template v-slot:[`item.code`]="{ item }">
                    <span class="font-weight-bold blue-grey--text text--darken-3">{{ item.code }}</span>
                </template>

                <!-- Hiển thị tên chi nhánh / phòng ban -->
                <template v-slot:[`item.departmentName`]="{ item }">
                    <div class="subtitle-2 font-weight-medium" style="line-height: 1.2;">{{ item.departmentName }}</div>
                </template>

                <!-- Hiển thị chip trạng thái -->
                <template v-slot:[`item.status`]="{ item }">
                    <v-chip :color="formatStatusColor(item.status)" small dark class="font-weight-bold"
                        style="min-width: 90px; justify-content: center;">
                        {{ formatStatusText(item.status) }}
                    </v-chip>
                </template>

                <!-- Hiển thị người tạo -->
                <template v-slot:[`item.createdByName`]="{ item }">
                    <div class="d-flex align-center" v-if="item.createdByName">
                        <v-avatar size="24" color="teal lighten-4" class="mr-2">
                            <v-icon x-small color="teal darken-3">mdi-account</v-icon>
                        </v-avatar>
                        <span class="caption font-weight-medium">{{ item.createdByName }}</span>
                    </div>
                    <span v-else class="caption grey--text text--lighten-1">--</span>
                </template>

                <!-- Cột Tạo vào: định dạng dd/MM/yyyy HH:mm:ss -->
                <template v-slot:[`item.createdAt`]="{ item }">
                    <div class="caption grey--text text--darken-2 font-weight-medium" v-if="item.createdAt">
                        <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
                        {{ formatDateTime(item.createdAt) }}
                    </div>
                    <span v-else class="caption grey--text text--lighten-1">--</span>
                </template>

                <!-- Hiển thị người tiếp nhận -->
                <template v-slot:[`item.receivedByName`]="{ item }">
                    <div class="d-flex align-center" v-if="item.receivedByName">
                        <v-avatar size="24" color="blue lighten-4" class="mr-2">
                            <v-icon x-small color="blue darken-3">mdi-account-check</v-icon>
                        </v-avatar>
                        <span class="caption font-weight-medium">{{ item.receivedByName }}</span>
                    </div>
                    <span v-else class="caption grey--text text--lighten-1 font-italic">Chưa tiếp nhận</span>
                </template>

                <!-- Cột Tiếp nhận vào: định dạng dd/MM/yyyy HH:mm:ss -->
                <template v-slot:[`item.receivedAt`]="{ item }">
                    <div class="caption grey--text text--darken-2" v-if="item.receivedAt">
                        <v-icon x-small class="mr-1">mdi-clock-check-outline</v-icon>
                        {{ formatDateTime(item.receivedAt) }}
                    </div>
                    <span v-else class="caption grey--text text--lighten-1 font-italic">Chưa tiếp nhận</span>
                </template>

                <!-- Khi không có dữ liệu -->
                <template v-slot:no-data>
                    <div class="py-8 grey--text text--darken-1 text-center">
                        <v-icon large color="grey lighten-1" class="mb-2">mdi-database-off</v-icon>
                        <div>Không tìm thấy dữ liệu phiếu yêu cầu</div>
                    </div>
                </template>
            </v-data-table>
        </v-card>

        <!-- ************** DIALOG TIẾP NHẬN HÀNG LOẠT *************** -->
        <v-dialog v-model="receiveDialog" max-width="500px">
            <v-card class="rounded-xl overflow-hidden">
                <v-card-title class="orange darken-4 white--text py-3 px-5">
                    <v-icon left color="white">mdi-check-all</v-icon>
                    <span class="text-subtitle-1 font-weight-bold">Tiếp nhận phiếu hàng loạt</span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark small @click="receiveDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pt-5 pb-2 px-6">
                    <div class="mb-3 text-body-2 grey--text text--darken-2">
                        Chọn khoảng thời gian để tiếp nhận các phiếu yêu cầu công cụ dụng cụ:
                    </div>
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-text-field hide-details v-model="receive.from" outlined label="Từ ngày" type="date" dense class="rounded-lg"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field hide-details v-model="receive.to" outlined label="Đến ngày" type="date" dense class="rounded-lg"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pb-5 px-6 justify-center">
                    <v-btn color="grey darken-1" text class="rounded-pill px-5" @click="receiveDialog = false">Hủy</v-btn>
                    <v-btn color="orange darken-4" dark class="rounded-pill px-6 elevation-2 font-weight-bold" @click="receiveMultiple">
                        <v-icon left small>mdi-check</v-icon> Tiếp nhận
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- ************** DIALOG XUẤT EXCEL *************** -->
        <v-dialog v-model="dialogExcel" max-width="500px">
            <v-card class="rounded-xl overflow-hidden">
                <v-card-title class="teal darken-4 white--text py-3 px-5">
                    <v-icon left color="white">mdi-file-excel</v-icon>
                    <span class="text-subtitle-1 font-weight-bold">Xuất dữ liệu Excel</span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark small @click="dialogExcel = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pt-5 pb-2 px-6">
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="excel.from" label="Từ ngày" hide-details outlined type="date" dense class="rounded-lg"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="excel.to" label="Đến ngày" hide-details outlined type="date" dense class="rounded-lg"></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mt-2">
                            <v-select :items="[
                                { text: 'Mới', value: 0 },
                                { text: 'Tiếp nhận', value: 1 },
                                { text: 'Hoàn thành', value: 2 },
                                { text: 'Từ chối', value: 3 },
                                { text: 'Đang nhập', value: -1 }
                            ]" v-model="excel.status" label="Trạng thái" outlined dense hide-details class="rounded-lg"></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pb-5 px-6 justify-center">
                    <v-btn color="grey darken-1" text class="rounded-pill px-5" @click="dialogExcel = false">Hủy</v-btn>
                    <v-btn color="teal darken-4" dark class="rounded-pill px-6 elevation-2 font-weight-bold" @click="exportExcel">
                        <v-icon left small>mdi-download</v-icon> Xuất Excel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- ************** DIALOG XÁC NHẬN XÓA *************** -->
        <v-dialog v-model="dialogDelete" max-width="450px">
            <v-card class="rounded-xl overflow-hidden">
                <v-card-title class="headline grey lighten-4 py-3 px-5">
                    <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
                    <span class="text-subtitle-1 font-weight-bold">Xác nhận xóa</span>
                </v-card-title>
                <v-card-text class="pt-6 text-center subtitle-1">
                    Bạn có chắc muốn xoá dữ liệu phiếu <b class="error--text">{{ targetItem ? targetItem.code : '' }}</b> này không?
                    <div class="mt-2 caption grey--text">Hành động này không thể hoàn tác.</div>
                </v-card-text>
                <v-card-actions class="pb-5 px-6 justify-center">
                    <v-btn color="grey darken-1" text class="rounded-pill px-5" @click="dialogDelete = false">Hủy bỏ</v-btn>
                    <v-btn color="error" class="rounded-pill px-6 elevation-2 font-weight-bold" @click="cfmDeleteItem">Xác nhận xóa</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import CreateDialog from './Create.vue';
import http from '@/components/services/http-common';
import moment from 'moment/moment';

export default {
    name: 'PropertyRequestConfirmIndex',
    components: {
        'create-dialog': CreateDialog,
    },
    watch: {
        dialog(val) {
            if (!val) {
                this.item = null;
            }
        },
        from() {
            this.fetchData();
        },
        to() {
            this.fetchData();
        }
    },
    data() {
        return {
            // Bộ lọc và tìm kiếm
            search: '',
            filterCode: '',
            filterStatus: null,
            filterDepartment: '',
            statusFilterOptions: [
                { text: 'Tất cả trạng thái', value: null },
                { text: 'Mới', value: 0 },
                { text: 'Tiếp nhận', value: 1 },
                { text: 'Hoàn thành', value: 2 },
                { text: 'Từ chối', value: 3 },
                { text: 'Đang nhập', value: -1 },
            ],
            from: moment().startOf('month').format('YYYY-MM-DD'),
            to: moment().endOf('month').format('YYYY-MM-DD'),

            // Trạng thái bảng và dữ liệu
            isLoading: false,
            items: [],
            item: null,
            dialog: false,

            // Cấu hình cột bảng dữ liệu
            headers: [
                { text: 'Thao tác', value: 'actions', width: '8rem', align: 'center', sortable: false },
                { text: 'Mã', value: 'code', width: '8rem' },
                { text: 'Phòng ban', value: 'departmentName', width: '16rem' },
                { text: 'Trạng thái', value: 'status', width: '9rem', align: 'center' },
                { text: 'Tạo bởi', value: 'createdByName', width: '14rem' },
                { text: 'Tạo vào', value: 'createdAt', width: '14rem', align: 'center' },
                { text: 'Tiếp nhận bởi', value: 'receivedByName', width: '14rem' },
                { text: 'Tiếp nhận vào', value: 'receivedAt', width: '14rem', align: 'center' },
            ],

            // Cấu hình xuất Excel
            dialogExcel: false,
            excel: {
                from: moment().startOf('month').format('YYYY-MM-DD'),
                to: moment().endOf('month').format('YYYY-MM-DD'),
                status: 1,
            },

            // Cấu hình xóa
            dialogDelete: false,
            targetItem: null,

            // Cấu hình tiếp nhận hàng loạt
            receiveDialog: false,
            receive: {
                from: moment().startOf('month').format('YYYY-MM-DD'),
                to: moment().endOf('month').format('YYYY-MM-DD'),
            }
        };
    },
    computed: {
        // Lọc danh sách theo các tiêu chí trên giao diện
        filteredItems() {
            return this.items.filter(item => {
                // Lọc theo mã phiếu
                if (this.filterCode && this.filterCode.trim()) {
                    const code = (item.code || '').toLowerCase();
                    if (!code.includes(this.filterCode.trim().toLowerCase())) {
                        return false;
                    }
                }
                // Lọc theo trạng thái
                if (this.filterStatus !== null && this.filterStatus !== undefined && this.filterStatus !== '') {
                    const itemText = this.formatStatusText(item.status);
                    const filterText = this.formatStatusText(this.filterStatus);
                    if (itemText !== filterText && item.status !== this.filterStatus) {
                        return false;
                    }
                }
                // Lọc theo phòng ban
                if (this.filterDepartment && this.filterDepartment.trim()) {
                    const dept = (item.departmentName || '').toLowerCase();
                    if (!dept.includes(this.filterDepartment.trim().toLowerCase())) {
                        return false;
                    }
                }
                return true;
            });
        }
    },
    methods: {
        // Định dạng ngày giờ chuẩn dd/MM/yyyy HH:mm:ss theo yêu cầu
        formatDateTime(value) {
            if (!value) return '';
            const m = moment(value);
            return m.isValid() ? m.format('DD/MM/YYYY HH:mm:ss') : value;
        },

        // Chuẩn hóa tên trạng thái để hiển thị đồng bộ
        formatStatusText(status) {
            if (status === 0 || status === '0' || status === 'Mới') return 'Mới';
            if (status === 1 || status === '1' || status === 'Đã nhận' || status === 'Tiếp nhận') return 'Tiếp nhận';
            if (status === 2 || status === '2' || status === 'Hoàn thành' || status === 'Hoàn tất') return 'Hoàn thành';
            if (status === 3 || status === '3' || status === 'Chối từ' || status === 'Từ chối') return 'Chối từ';
            if (status === -1 || status === '-1' || status === 'Đang nhập') return 'Đang nhập';
            return status !== null && status !== undefined ? String(status) : '--';
        },

        // Màu sắc đại diện cho trạng thái tương ứng
        formatStatusColor(status) {
            const text = this.formatStatusText(status);
            switch (text) {
                case 'Mới': return 'blue lighten-1';
                case 'Tiếp nhận': return 'orange lighten-1';
                case 'Hoàn thành': return 'success';
                case 'Chối từ': return 'error';
                case 'Đang nhập': return 'blue-grey lighten-1';
                default: return 'grey';
            }
        },

        // Lấy danh sách phiếu từ server
        fetchData() {
            this.isLoading = true;
            return http.get('propertyRequests', {
                params: {
                    from: this.from,
                    to: this.to
                }
            }).then(res => {
                this.items = res.data.data || [];
            }).catch(err => {
                console.error('Lỗi khi tải danh sách phiếu:', err);
            }).finally(() => {
                this.isLoading = false;
            });
        },

        // Thiết lập chọn mã phiếu
        setSelect(e) {
            this.item = { code: e };
        },

        // Mở dialog tạo mới phiếu
        createItem() {
            this.item = null;
            this.dialog = true;
        },

        // Mở dialog chi tiết / chỉnh sửa phiếu
        edit(item) {
            this.item = item;
            this.dialog = true;
        },

        // Mở dialog xác nhận xóa phiếu
        deleteItem(item) {
            this.targetItem = item;
            this.dialogDelete = true;
        },

        // Xác nhận xóa phiếu từ server
        cfmDeleteItem() {
            if (!this.targetItem || !this.targetItem.code) return;
            const url = `propertyRequests/${this.targetItem.code}`;
            return http.delete(url).then(() => {
                this.fetchData();
                this.dialogDelete = false;
            }).catch(err => {
                if (err && err.response && err.response.status === 403) {
                    this.unauthorizeAlert();
                }
                this.dialogDelete = false;
            });
        },

        // Thông báo không có quyền thao tác
        unauthorizeAlert() {
            if (this.$Swal) {
                this.$Swal.fire({
                    icon: 'error',
                    title: 'Không có phân quyền',
                    text: 'Bạn không có quyền thực hiện thao tác này',
                });
            } else {
                alert('Bạn không có quyền thực hiện thao tác này');
            }
        },

        // Xuất file Excel theo điều kiện lọc
        exportExcel() {
            const url = 'PropertyRequests/month-excel';
            return http.get(url, {
                params: this.excel,
                responseType: 'arraybuffer',
            }).then(res => {
                const blob = new Blob([res.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Danh_sach_phieu_CCDC.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                this.dialogExcel = false;
            }).catch(err => {
                console.error('Lỗi khi xuất excel:', err);
            });
        },

        // Tiếp nhận hàng loạt phiếu theo khoảng ngày
        receiveMultiple() {
            if (!this.receive.from || !this.receive.to) {
                alert('Từ ngày và đến ngày không được để trống');
                return;
            }
            return http.get('propertyRequests/receive/multiple', {
                params: {
                    from: moment(this.receive.from).format('YYYY-MM-DD'),
                    to: moment(this.receive.to).format('YYYY-MM-DD')
                }
            }).then(() => {
                this.receiveDialog = false;
                this.fetchData();
            }).catch(err => {
                console.error('Lỗi tiếp nhận hàng loạt:', err);
            });
        }
    },
    mounted() {
        this.fetchData();
    }
};
</script>

<style scoped>
.property-request-confirm {
    padding: 8px;
}
</style>